import {FC, useState, useEffect} from 'react'

import DetailMemberModal from './DetailMemberModal'
import FormPresention from './FormPresention'

type Props = {
  data: any
  allowEdit: boolean
  reloadData: any
}

const MemberContent: FC<Props> = ({data, allowEdit, reloadData}) => {
  const [detail, setDetail] = useState<any>({})
  const [showDetailMember, setShowDetailMember] = useState<boolean>(false)
  const [detailUser, setDetailUser] = useState<any>({})
  const [showFormModal, setShowFormModal] = useState(false)
  const [presention, setPresention] = useState({})

  useEffect(() => {
    setDetail(data)
  }, [data])

  const handleCloseModal = (action: boolean) => {
    setShowDetailMember(action)
  }

  const handleShowMember = (email: any) => {
    setShowDetailMember(true)

    setDetailUser({
      email: email,
    })
  }

  const handelTogglePresention = (item: any, userId: any, panaId: any) => {
    setShowFormModal(!showFormModal)

    setPresention({
      ...item,
      ...{
        user_id: userId,
        id_pendaftaran_pana: panaId,
      },
    })
  }

  const handleCloseFormModal = () => {
    setShowFormModal(false)
  }

  const handleReloadData = (isReload: boolean) => {
    if (typeof reloadData == 'function') {
      reloadData(isReload)
    }
  }

  return (
    <>
      <DetailMemberModal
        showModal={showDetailMember}
        handleCloseModal={handleCloseModal}
        email={detailUser}
      />

      <FormPresention
        showFormModal={showFormModal}
        handleCloseFormModal={handleCloseFormModal}
        presention={presention}
        reloadData={handleReloadData}
      />

      <div className='card'>
        <div className='p-7 border-bottom'>
          <div className='d-flex align-items-center gap-3'>
            <div className='icon-box px-2 py-2 rounded'>
              <i className='fa fa-user-friends fa-bars text-dark'></i>
            </div>
            <p className='fs-4 fw-bold'>Anggota</p>
          </div>
        </div>
        <div className='px-8'>
          <div className='row pb-8'>
            {/* Ketua Kelompok */}
            <div className={`col-md-${detail?.anggota?.length > 0 ? 6 : 12} mt-3`}>
              <div style={{backgroundColor: '#F4F7FE'}} className='border rounded p-6 mt-4'>
                <div
                  className='d-flex justify-content-between align-items-center'
                  style={{backgroundColor: '#F4F7FE'}}
                >
                  <div
                    style={{cursor: 'pointer'}}
                    onClick={() => handleShowMember(detail?.users?.email)}
                  >
                    <p className='fw-bold mb-1'>
                      <i className='bi bi-person-circle text-black' /> {detail?.users?.fullname}
                    </p>

                    {allowEdit && (
                      <p className='text-muted mb-0' style={{fontSize: '0.85rem'}}>
                        Catatan kehadiran: {detail?.users?.presensi?.catatan}
                      </p>
                    )}
                  </div>

                  <div className='d-flex align-items-center gap-2'>
                    {detail?.anggota?.length > 0 && (
                      <span className='px-3 border bg-secondary rounded'>Ketua Kelompok</span>
                    )}

                    {allowEdit && (
                      <button
                        onClick={() =>
                          handelTogglePresention(
                            detail?.users?.presensi,
                            detail?.users?.users_id,
                            data?.id
                          )
                        }
                        className={`badge ${
                          detail?.users?.presensi && detail?.users?.presensi?.is_hadir == 0
                            ? 'bg-secondary text-primary'
                            : 'bg-success text-white'
                        }`}
                        style={{cursor: 'pointer'}}
                      >
                        {detail?.users?.presensi && detail?.users?.presensi?.is_hadir == 0
                          ? 'Tidak Hadir'
                          : 'Hadir'}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Anggota lainnya */}
            {detail?.anggota?.map((item: any, index: any) => {
              return (
                <div className='col-md-6 mt-3' key={index}>
                  <div style={{backgroundColor: '#F4F7FE'}} className='border rounded p-6 mt-4'>
                    <div
                      className='d-flex justify-content-between align-items-center'
                      style={{backgroundColor: '#F4F7FE'}}
                    >
                      <div
                        style={{cursor: 'pointer'}}
                        onClick={() => handleShowMember(item?.email)}
                      >
                        <p className='fw-bold mb-1'>
                          <i className='bi bi-person-circle text-black' />{' '}
                          {item?.users?.fullname ?? item?.nama_anggota}
                        </p>

                        {allowEdit && (
                          <p className='text-muted mb-0' style={{fontSize: '0.85rem'}}>
                            Catatan kehadiran: {item?.presensi?.catatan}
                          </p>
                        )}
                      </div>

                      {allowEdit && (
                        <button
                          onClick={() =>
                            handelTogglePresention(item?.presensi, item?.users_id, data?.id)
                          }
                          className={`badge ${
                            item.presensi && item.presensi?.is_hadir == 0
                              ? 'bg-secondary text-primary'
                              : 'bg-success text-white'
                          }`}
                          style={{cursor: 'pointer'}}
                        >
                          {item.presensi && item.presensi?.is_hadir == 0 ? 'Tidak Hadir' : 'Hadir'}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

const Member: FC<Props> = ({data, allowEdit, reloadData}) => {
  return <MemberContent data={data} allowEdit={allowEdit} reloadData={reloadData} />
}

export default Member
